import PropTypes from 'prop-types'
import React, { Component } from 'react'
import {

  Link
} from "react-router-dom"

const Navbar =()=> {



  
    return (
      
        <nav className="navbar navbar-expand-lg fixed-top navbar-dark bg-primary "
         
         >
  <div className="container-fluid">
    <Link className="navbar-brand" to="/">The News</Link>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav me-auto mb-2 mb-lg-0">
        <li className="nav-item">
          <Link className="nav-link active" aria-current="page" to="/general">Home</Link>
        </li>
        <li className="nav-item">
          <Link className="nav-link active" to="#">About Us</Link>
        </li>
        <li className="nav-item dropdown ">
          <a className="nav-link dropdown-toggle active" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Categories
          </a>
          <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
          <li><Link className="dropdown-item" to="/science">Science</Link></li>
    <li><Link className="dropdown-item" to="/business">Business</Link></li>
    <li><Link className="dropdown-item" to="/sports">Sports</Link></li>
    <li><Link className="dropdown-item" to="/health">Health</Link></li>
    <li><Link className="dropdown-item" to="/technology">Technology</Link></li>
    <li><Link className="dropdown-item" to="/entertainment">Entertainment</Link></li>
          </ul>
        </li>
       
      </ul>
      
    </div>
   
  </div>
</nav>
      
    )
  }


export default Navbar